(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-contact"] && !Shopify.designMode) return;
  try {
    
  function artContactInit() {
    document.querySelectorAll('.art-contact__copy').forEach(function (btn) {
      if (btn.dataset.artReady === '1') return;
      btn.dataset.artReady = '1';
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-art-copy') || '';
        var done = function () {
          var old = btn.textContent;
          btn.textContent = 'Kopyalandı ✓';
          btn.classList.add('copied');
          setTimeout(function () { btn.textContent = old; btn.classList.remove('copied'); }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(val).then(done).catch(done);
        } else {
          var t = document.createElement('textarea');
          t.value = val; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t); done();
        }
      });
    });
  }
  if (document.readyState !== 'loading') { artContactInit(); }
  else { document.addEventListener('DOMContentLoaded', artContactInit); }
  document.addEventListener('shopify:section:load', artContactInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-header"] && !Shopify.designMode) return;
  try {
    
  function artHeaderInit() {
    document.querySelectorAll('.art-cats').forEach(function (cats) {
      if (cats.dataset.artReady === '1') return;
      cats.dataset.artReady = '1';
      cats.querySelectorAll('.art-cats__cat').forEach(function (cat) {
        cat.addEventListener('mouseenter', function () {
          var id = cat.getAttribute('data-art-cat');
          cats.querySelectorAll('.art-cats__cat').forEach(function (x) { x.classList.remove('on'); });
          cats.querySelectorAll('.art-cats__sub').forEach(function (x) { x.classList.remove('on'); });
          cat.classList.add('on');
          var target = cats.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
          if (target) target.classList.add('on');
        });
      });
    });

    var panel = document.querySelector('[data-art-mobile]');
    if (panel && panel.dataset.artReady !== '1') {
      panel.dataset.artReady = '1';
      function open() { panel.hidden = false; document.body.style.overflow = 'hidden'; }
      function close() { panel.hidden = true; document.body.style.overflow = ''; }
      document.querySelectorAll('[data-art-menu-toggle]').forEach(function (t) { t.addEventListener('click', open); });
      document.querySelectorAll('[data-art-menu-close]').forEach(function (c) { c.addEventListener('click', close); });
      panel.addEventListener('click', function (e) { if (e.target === panel) close(); });
    }

    var qd = document.querySelector('[data-art-quote]');
    if (qd && qd.dataset.artReady !== '1') {
      qd.dataset.artReady = '1';
      document.querySelectorAll('[data-art-quote-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (typeof qd.showModal === 'function') { qd.showModal(); } else { qd.setAttribute('open', ''); }
        });
      });
      qd.querySelectorAll('[data-art-quote-close]').forEach(function (c) {
        c.addEventListener('click', function () { qd.close(); });
      });
      qd.addEventListener('click', function (e) { if (e.target === qd) qd.close(); });
      var qf = qd.querySelector('[data-art-quote-form]');
      if (qf) {
        qf.addEventListener('submit', function (e) {
          e.preventDefault();
          var num = (qd.getAttribute('data-wa') || '').replace(/[^0-9]/g, '');
          var get = function (n) { var el = qf.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
          var txt = 'Merhaba, özel üretim / teklif almak istiyorum.\n\n' +
            'İşletme / Ad: ' + get('name') + '\n' +
            'Telefon: ' + get('phone');
          var msg = get('message');
          if (msg) { txt += '\nİhtiyaç: ' + msg; }
          window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(txt), '_blank');
          qd.close();
          qf.reset();
        });
      }
    }
  }

  if (document.readyState !== 'loading') {
    artHeaderInit();
  } else {
    document.addEventListener('DOMContentLoaded', artHeaderInit);
  }
  document.addEventListener('shopify:section:load', artHeaderInit);

  // ===== CART DRAWER =====
  function artTL(cents) { return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺'; }
  function artCartEl() { return document.querySelector('[data-art-cart]'); }
  function artThresholdFor(cart) {
    var d = artCartEl(); if (!d) return 1000000;
    var gen = parseInt(d.getAttribute('data-th-gen'), 10) || 10000;
    var art = parseInt(d.getAttribute('data-th-art'), 10) || 2000;
    var types = (d.getAttribute('data-art-types') || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
    var allArt = cart.items && cart.items.length > 0 && cart.items.every(function (it) { return types.indexOf((it.product_type || '').toLowerCase()) > -1; });
    return (allArt ? art : gen) * 100;
  }
  function artUpdateBadge(n) {
    document.querySelectorAll('[data-art-cart-count]').forEach(function (e) { e.textContent = n; });
    document.querySelectorAll('.art-header__badge').forEach(function (b) { b.hidden = (n <= 0); });
  }
  function artRenderShip(total, th) {
    var wrap = document.querySelector('[data-art-ship]'); if (!wrap) return;
    var txt = wrap.querySelector('[data-art-ship-text]');
    var fill = wrap.querySelector('[data-art-ship-fill]');
    if (total >= th) {
      wrap.classList.add('done');
      txt.innerHTML = '🎉 <b>Tebrikler!</b> Ücretsiz kargoyu kazandınız.';
      fill.style.width = '100%';
    } else {
      wrap.classList.remove('done');
      txt.innerHTML = 'Ücretsiz kargoya <b>' + artTL(th - total) + '</b> kaldı!';
      fill.style.width = Math.min(100, total / th * 100) + '%';
    }
  }
  function artRenderCart(cart) {
    artUpdateBadge(cart.item_count);
    var box = document.querySelector('[data-art-cart-items]'); if (!box) return;
    if (!cart.items || !cart.items.length) {
      box.innerHTML = '<div class="art-cart__empty">Sepetiniz henüz boş.</div>';
    } else {
      box.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image : '';
        return '<div class="art-cart__item" data-key="' + it.key + '">'
          + '<div class="art-cart__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>'
          + '<div><a class="art-cart__title" href="' + it.url + '">' + it.product_title + '</a>'
          + '<div class="art-cart__uprice">' + artTL(it.final_price) + '</div>'
          + '<div class="art-cart__qty"><button type="button" data-art-q="-1">−</button><span>' + it.quantity + '</span><button type="button" data-art-q="1">+</button></div>'
          + '<button type="button" class="art-cart__rm" data-art-rm>Kaldır</button></div>'
          + '<div class="art-cart__lineprice">' + artTL(it.final_line_price) + '</div></div>';
      }).join('');
    }
    document.querySelectorAll('[data-art-cart-subtotal]').forEach(function (e) { e.textContent = artTL(cart.total_price); });
    artRenderShip(cart.total_price, artThresholdFor(cart));
  }
  function artFetchCart(cb) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { artRenderCart(c); if (cb) cb(c); });
  }
  function artOpenCart() { artFetchCart(function () { var d = artCartEl(); if (d) { d.hidden = false; document.body.style.overflow = 'hidden'; } }); }
  function artCloseCart() { var d = artCartEl(); if (d) { d.hidden = true; document.body.style.overflow = ''; } }
  function artChange(key, q) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(artRenderCart);
  }
  function artCartInit() {
    if (document.body.dataset.artCartReady === '1') return;
    document.body.dataset.artCartReady = '1';
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-art-cart-open]')) { e.preventDefault(); artOpenCart(); return; }
      if (e.target.closest('[data-art-cart-close]')) { artCloseCart(); return; }
      var item = e.target.closest('.art-cart__item');
      var qb = e.target.closest('[data-art-q]');
      if (qb && item) { var d = parseInt(qb.getAttribute('data-art-q'), 10); var q = parseInt(item.querySelector('.art-cart__qty span').textContent, 10) + d; artChange(item.getAttribute('data-key'), Math.max(0, q)); return; }
      if (e.target.closest('[data-art-rm]') && item) { artChange(item.getAttribute('data-key'), 0); return; }
    });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var action = form && form.getAttribute && form.getAttribute('action');
      if (action && action.indexOf('/cart/add') > -1) {
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        if (btn) { btn.disabled = true; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function () { if (btn) { btn.disabled = false; } artOpenCart(); })
          .catch(function () { if (btn) { btn.disabled = false; } });
      }
    });
    artFetchCart();
  }
  if (document.readyState !== 'loading') { artCartInit(); } else { document.addEventListener('DOMContentLoaded', artCartInit); }

  /* ===== CANLI ARAMA (PREDICTIVE) ===== */
  function artPredPrice(s) {
    var n = parseFloat(s);
    if (isNaN(n)) return '';
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
  }
  function artPredFetch(q, box) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var items = (d.resources && d.resources.results && d.resources.results.products) || [];
      if (!items.length) {
        box.innerHTML = '<div class="art-pred__empty">Sonuç bulunamadı</div>';
        box.hidden = false; return;
      }
      var html = items.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var price = p.price ? artPredPrice(p.price) : '';
        var t = (p.title || '').replace(/</g, '&lt;');
        return '<a class="art-pred__item" href="' + p.url + '">' +
          (img ? '<img src="' + img + '&width=92" alt="" loading="lazy">' : '<span class="art-pred__noimg"></span>') +
          '<span class="art-pred__t">' + t + '</span>' +
          (price ? '<span class="art-pred__p">' + price + '</span>' : '') + '</a>';
      }).join('');
      html += '<a class="art-pred__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Tüm sonuçları gör →</a>';
      box.innerHTML = html;
      box.hidden = false;
    }).catch(function () { box.hidden = true; });
  }
  function artPredInit() {
    document.querySelectorAll('[data-art-search]').forEach(function (form) {
      var input = form.querySelector('[data-art-search-input]');
      var box = form.querySelector('[data-art-pred]');
      if (!input || !box || input.dataset.predBound) return;
      input.dataset.predBound = '1';
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
        timer = setTimeout(function () { artPredFetch(q, box); }, 220);
      });
      input.addEventListener('focus', function () {
        if (box.innerHTML.trim() && input.value.trim().length >= 2) box.hidden = false;
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) box.hidden = true;
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
    });
  }
  if (document.readyState !== 'loading') { artPredInit(); } else { document.addEventListener('DOMContentLoaded', artPredInit); }
  document.addEventListener('shopify:section:load', artPredInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-product"]) return;
  try {
    
  function artPdInit(root) {
    if (!root || root.dataset.artReady === '1') return;
    root.dataset.artReady = '1';

    var main = root.querySelector('#artPdMain');
    root.querySelectorAll('.art-pd__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.art-pd__thumb').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        if (main) main.src = t.getAttribute('data-src');
      });
    });

    root.querySelectorAll('.art-pd__tabnav button').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.art-pd__tabnav button').forEach(function (x) { x.classList.remove('on'); });
        root.querySelectorAll('.art-pd__pane').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var pane = root.querySelector('#' + b.getAttribute('data-t'));
        if (pane) pane.classList.add('on');
      });
    });
    var revLink = root.querySelector('[data-art-reviews]');
    if (revLink) revLink.addEventListener('click', function (e) {
      e.preventDefault();
      var rb = root.querySelector('.art-pd__tabnav button[data-t="rev"]');
      if (rb) rb.click();
      root.querySelector('#artReviews').scrollIntoView({ behavior: 'smooth' });
    });

    var qi = root.querySelector('[data-art-qtyinput]');
    root.querySelectorAll('[data-art-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.getAttribute('data-art-qty'), 10);
        var val = Math.max(1, (parseInt(qi.value, 10) || 1) + d);
        qi.value = val;
      });
    });

    var modal = document.querySelector('[data-art-tx]');
    var priceEl = root.querySelector('#artPdPrice');
    var variantSel = root.querySelector('[data-art-variant]');
    if (variantSel) {
      variantSel.addEventListener('change', function () {
        var opt = variantSel.options[variantSel.selectedIndex];
        if (priceEl) priceEl.textContent = opt.getAttribute('data-price');
        if (modal) modal.setAttribute('data-base', opt.getAttribute('data-amount'));
      });
    }

    if (modal && modal.dataset.artReady !== '1') {
      modal.dataset.artReady = '1';
      var fmt = function (v) { return v.toLocaleString('tr-TR', { maximumFractionDigits: 2 }) + ' ₺'; };
      var build = function () {
        var base = (parseInt(modal.getAttribute('data-base'), 10) || 0) / 100;
        var rates = [
          { n: 2, r: parseFloat(modal.getAttribute('data-r2')) || 0 },
          { n: 3, r: parseFloat(modal.getAttribute('data-r3')) || 0 },
          { n: 6, r: parseFloat(modal.getAttribute('data-r6')) || 0 },
          { n: 9, r: parseFloat(modal.getAttribute('data-r9')) || 0 }
        ];
        var ps = modal.querySelector('[data-tx-price]');
        if (ps) ps.textContent = fmt(base);
        var rows = '<tr><td>Tek Çekim</td><td>—</td><td>' + fmt(base) + '</td></tr>';
        rows += rates.map(function (o) {
          var total = base * (1 + o.r / 100);
          return '<tr><td>' + o.n + ' Taksit</td><td>' + fmt(total / o.n) + '</td><td>' + fmt(total) + '</td></tr>';
        }).join('');
        modal.querySelector('[data-tx-body]').innerHTML = rows;
      };
      root.querySelectorAll('[data-tx-open]').forEach(function (b) {
        b.addEventListener('click', function () { build(); if (modal.showModal) modal.showModal(); });
      });
      var tc = modal.querySelector('[data-tx-close]');
      if (tc) tc.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }
  }

  function artPdInitAll() { document.querySelectorAll('.art-pd').forEach(artPdInit); }
  if (document.readyState !== 'loading') { artPdInitAll(); }
  else { document.addEventListener('DOMContentLoaded', artPdInitAll); }
  document.addEventListener('shopify:section:load', artPdInitAll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-slideshow"] && !Shopify.designMode) return;
  try {
    
  function artInitSlideshow(root) {
    if (!root || root.dataset.artInit === '1') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.art-slide'));
    if (!slides.length) return;
    root.dataset.artInit = '1';

    var dots = Array.prototype.slice.call(root.querySelectorAll('.art-dot'));
    var current = 0;
    var timer = null;

    function show(n) {
      current = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('on', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === current); });
    }

    function next(step) { show(current + step); }

    slides.forEach(function (s, i) { s.classList.toggle('on', i === 0); });
    dots.forEach(function (d, i) { d.classList.toggle('on', i === 0); });

    root.querySelectorAll('.art-arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        next(parseInt(btn.getAttribute('data-dir'), 10) || 1);
        restart();
      });
    });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-index'), 10) || 0);
        restart();
      });
    });

    function restart() {
      if (timer) { clearInterval(timer); timer = null; }
      if (root.dataset.autoplay === 'true' && slides.length > 1) {
        var speed = parseInt(root.dataset.speed, 10) || 6000;
        timer = setInterval(function () { next(1); }, speed);
      }
    }

    restart();
  }

  function artInitAllSlideshows() {
    document.querySelectorAll('.art-slideshow').forEach(artInitSlideshow);
  }

  if (document.readyState !== 'loading') {
    artInitAllSlideshows();
  } else {
    document.addEventListener('DOMContentLoaded', artInitAllSlideshows);
  }

  document.addEventListener('shopify:section:load', artInitAllSlideshows);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
